import styled from 'styled-components';

export const GuessesRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 4px 0;
`;
